import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { filter, first, map, tap } from 'rxjs/operators';

import { LocationsRouterStoreSelectors } from '@era/stores';
import { isNonEmptyString } from '@rocksoft/shared';
import { Observable, of } from 'rxjs';
import { DeviceSyncStatusActions } from '../../device-sync/device-sync-statuses-store';

@Injectable({ providedIn: 'root' })
export class DeviceSyncStatusResolver {
  private readonly store = inject(Store);

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    // Get the categoryId from the route parameters if it has a locationId, otherwise return undefined
    // This is needed to let this resolver also work for the '/unavailable' and '/unassigned' routes,
    // which do not have a locationId in the route parameters.
    const categoryId$: Observable<string | undefined> = route.paramMap.has('locationId')
      ? this.store
          .select(LocationsRouterStoreSelectors.selectLocationId)
          .pipe(filter((categoryId): categoryId is string => isNonEmptyString(categoryId)))
      : of(undefined);

    // Dispatch the syncStatusesRequested action with the categoryId.
    // If the categoryId is undefined, it will still dispatch the action with undefined and fetch the sync statuses for all categories.
    return categoryId$.pipe(
      tap((categoryId) => {
        this.store.dispatch(
          DeviceSyncStatusActions.DeviceSyncStatusResolverActions.syncStatusesRequested({ categoryId })
        );
      }),
      map(() => true),
      first()
    );
  }
}
